import { Paper } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledPaper = {
  Container: styled(Paper)(({ theme }) => ({
    display: "flex",
    padding: 20,
    marginBottom: 20,
  })),
};
